module.exports = __webpack_public_path__ + "static/media/fried-rice.d440606a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fried-rice.jpg
// module id = 199
// module chunks = 0